import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/** <cadence-badge color="#hex" variant="solid|soft|status"> — tag/status chip. */
@customElement('cadence-badge')
export class CadenceBadge extends LitElement {
  @property() color = '';
  @property() variant: 'solid' | 'soft' | 'status' = 'soft';

  static styles = css`
    :host { display: inline-block; }
    .badge {
      display: inline-flex; align-items: center; gap: 6px;
      padding: 2px 10px; border-radius: 999px;
      font-size: 0.78rem; font-weight: 600; line-height: 1.6;
      white-space: nowrap;
    }
    .dot { width: 8px; height: 8px; border-radius: 50%; background: var(--badge-color, var(--color-primary)); }
    .soft { background: color-mix(in srgb, var(--badge-color, var(--color-primary)) 16%, transparent); color: var(--badge-color, var(--color-primary)); }
    .solid { background: var(--badge-color, var(--color-primary)); color: #fff; }
    .status { background: var(--color-bg-secondary); color: var(--color-text-secondary); border: 1px solid var(--color-border); }
  `;

  render() {
    return html`
      <span class="badge ${this.variant}" style=${this.color ? `--badge-color:${this.color}` : ''}>
        ${this.variant === 'status' ? html`<span class="dot"></span>` : ''}
        <slot></slot>
      </span>
    `;
  }
}
